import React, { useState } from 'react'
import { Route, Switch } from 'react-router'
import clsx from 'clsx'

import Nav from './Nav'
import FlashMessage from '../flashMessage'
import AvailabilityMatchClick from '../availabilityMatchClick/Show'

import Imports from '../Realtime/Imports'
import RequestEdit from '../request/edit/Index'
import SiteSelectorModal from '../request/form/SitesSelector/Modal'
import Plan from '../Plan/Index'

import PagePremium from '../pages/premium'
import PageAbout from '../pages/about'

import Requests from '../request/Index'

import RequestForm from '../request/form/index'
import RequestFormSteps from '../request/form/steps'
import RequestShow from '../request/show/Index'

import FrontPage from '../FrontPage'

import Facility from '../facility/Show/Index'
import Site from '../site/Show/Index'

import SessionNew from '../sessions/new'
import SessionCreate from '../sessions/create'
import SessionDestroy from '../sessions/destroy'

import UserSettings from '../user/settings'
import requireAuth from '../sessions/authenticated'

import RequestStatusUpdate from '../request/StatusUpdate'

import FourOhFour from '../pages/FourOhFour'
import Header from './Header'

import FacilityGroupIndex from '../FacilityGroup/Index'
import FacilityGroupShow from '../FacilityGroup/Show/Index'
import Meta from './Meta'

if (process.env.NODE_ENV === 'production') {
  require('../../tailwind.generated.css')
} else {
  require('../../tailwind.all.css')
}

const LayoutV2 = () => {
  const [navOpen, setNavOpen] = useState(false)

  return (
    <div className="sans bg-white text-gray-700 min-h-screen">
      <Meta />
      <Header navClick={() => setNavOpen(!navOpen)} />
      <div className="container">
        <SiteSelectorModal />

        <div className="flex w-full">
          <Nav navOpen={navOpen} onClose={() => setNavOpen(false)} />

          <div className={clsx('my-1 pt-2 pb-2 px-6 flex-1', navOpen && '-ml-32')}>
            <FlashMessage />
            <Route path="/new" component={RequestFormSteps} />

            <Switch>
              <Route exact path="/premium" component={PagePremium} />
              <Route exact path="/about" component={PageAbout} />

              <Route exact path="/:from([wet]{1})/:id" component={AvailabilityMatchClick} />

              <Route path="/plan" component={Plan} />

              <Route path="/logs/:facilityId/:siteId" component={Imports} />
              <Route path="/logs/:facilityId" component={Imports} />
              <Route path="/logs" component={Imports} />

              <Route
                path="/edit/:uuid([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12})"
                component={RequestEdit}
              />

              <Route exact path="/" component={requireAuth(Requests, FrontPage)} />

              <Route exact path="/new" component={RequestForm} />
              <Route exact path="/new/:slug" component={RequestForm} />

              <Route
                exact
                path="/:uuid([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12})"
                component={RequestShow}
              />
              <Route
                exact
                path="/:status([cag]{1})/:uuid([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12})"
                component={RequestStatusUpdate}
              />

              <Route exact path="/explore/state/:state" component={FacilityGroupIndex} />
              <Route exact path="/explore/:id" component={FacilityGroupShow} />
              <Route exact path="/explore" component={FacilityGroupIndex} />

              <Route exact path="/f/:id" component={Facility} />
              <Route exact path="/f/:facilityId/s/:id" component={Site} />

              <Route exact path="/sign-in" component={SessionNew} />
              <Route exact path="/sign-in/:token" component={SessionCreate} />
              <Route
                exact
                path="/sign-in/:token/settings"
                render={props => <SessionCreate {...props} redirect="/settings" />}
              />
              <Route exact path="/sign-out" component={SessionDestroy} />

              <Route exact path="/settings" component={requireAuth(UserSettings, SessionNew)} />
              <Route path="*" component={FourOhFour} />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LayoutV2
